import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  ButtonGroup,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Card,
  Alert,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Tab,
  Tabs,
} from "react-bootstrap";

import * as Yup from "yup";
import moment from "moment";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

//Tabla, Navbar y Sidebar
import CustomNavbar from "../../components/CustomNavbar";

import Timeline from 'react-calendar-timeline'
import 'react-calendar-timeline/lib/Timeline.css'

//Redux
import {
  getMapaCarrera
} from "../../redux/planCarrera/MapaCarrera/actions"


import messages from "../../redux/messages";
import SidebarDashboard from "../../components/SidebarDashboard";

const MapaCarrera = (props) => {
  const [activeTab, setActiveTab] = useState('cursos')
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  //redux
  const {
    loading,
    mapaCarrera,
    mapaCarreraError

  } = useSelector((store) => store.planCarreraMapaCarrera)


  //Valores
  const groupsCourses = mapaCarrera.mapaCursos?.lista_cursos ? mapaCarrera.mapaCursos.lista_cursos : []
  const itemsCourses = mapaCarrera.mapaCursos?.list_cursos_historial ? mapaCarrera.mapaCursos.list_cursos_historial.flat().map(item => ({
    id: item.id,
    group: item.group,
    title: item.title,
    start_time: moment(item.start_time),
    end_time: item.end_time
      ? moment(item.end_time).add(1, 'day').startOf('day')
      : item.title === "Cerrado" ? moment(item.start_time).add(1, 'day').startOf('day') : moment().add(1, 'day').startOf('day'),
    canMove: false,
    canResize: false,
    canChangeGroup: false,
    itemProps: {
      style: {
        backgroundColor: item.title === "Iniciado" ? "#C4F7A3" : item.title === "Pendiente" ? "#F7D0A3" : "#F7BCBC",
        color: '#000',
        fontWeight: "bold",
      }
    }
  })) : []

  const groupsCompetencies = mapaCarrera.mapaCompetencias?.lista_competencia ? mapaCarrera.mapaCompetencias.lista_competencia : []
  const itemsCompetencies = mapaCarrera.mapaCompetencias?.list_competencia_historial ? mapaCarrera.mapaCompetencias.list_competencia_historial.flat().map(item => ({
    id: item.id,
    group: item.group,
    title: item.title,
    start_time: moment(item.start_time),
    end_time: item.end_time
      ? moment(item.end_time).add(1, 'day').startOf('day')
      : item.title === "Cerrado" ? moment(item.start_time).add(1, 'day').startOf('day') : moment().add(1, 'day').startOf('day'),
    canMove: false,
    canResize: false,
    canChangeGroup: false,
    itemProps: {
      style: {
        backgroundColor: item.title === "Iniciado" ? "#C4F7A3" : item.title === "Pendiente" ? "#F7D0A3" : "#F7BCBC",
        color: '#000',
        fontWeight: "bold",
      }
    }
  })) : []




  useEffect(() => {
    dispatch(getMapaCarrera({
      plan: props.match.params.planId
    }));
  }, [])

  useEffect(() => {

    const resizeTimeline = () => {
      window.dispatchEvent(new Event('resize'));
    };

    resizeTimeline();

    setTimeout(() => {
      resizeTimeline();
    }, 300);
  }, [activeTab]);


  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <Container fluid className="mt-5">
        {console.log(mapaCarrera)}
        {loading ? (
          <div className='d-flex justify-content-center'>
            <Spinner
              animation='border'
              role='status'
              className='d-flex justify-content-center'
            />
          </div>
        ) : (
          <>
            {(!mapaCarrera.mapaCursos?.list_cursos_historial?.length > 0 || !mapaCarrera.mapaCursos?.lista_cursos?.length > 0) && <Alert variant="info"> No hay cursos registrados, comience agregando algunos.</Alert>}
            {(!mapaCarrera.mapaCompetencias?.list_competencia_historial?.length > 0 || !mapaCarrera.mapaCompetencias?.list_competencia_historial?.length > 0) && <Alert variant="info"> No hay competencias registradas, comience agregando algunas.</Alert>}

            <Tabs
              activeKey={activeTab}
              onSelect={(e) => setActiveTab(e)}
              className="mb-3"
              mountOnEnter={false}
              unmountOnExit={false}
            >
              <Tab
                eventKey={"cursos"}
                title="Cursos"
              >
                <Timeline
                  groups={groupsCourses}
                  items={itemsCourses}
                  defaultView="month"
                  defaultTimeStart={moment().startOf('month')}
                  defaultTimeEnd={moment().endOf('month')}
                  stackItems={true}
                />
              </Tab>
              <Tab
                eventKey={"competencias"}
                title="Competencias"
              >
                <Timeline
                  groups={groupsCompetencies}
                  items={itemsCompetencies}
                  defaultView="month"
                  defaultTimeStart={moment().startOf('month')}
                  defaultTimeEnd={moment().endOf('month')}
                  stackItems={true}
                />

              </Tab>

            </Tabs>
          </>
        )}
      </Container>
    </>
  );
};

export default MapaCarrera;
